module.exports = "../content/6090d256d88dcd7f0244eaa4a3eafbba.ttf";